import { useState } from "react";
import { RotateCcw, Wand2 } from "lucide-react";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";

const TEXTS = {
  selection: {
    title: "¿Empezar una nueva selección?",
    body: "Se borrará la selección actual (incluidas tus decisiones manuales, las ganadoras y reservas de la IA) y la edición. Las fotos se volverán a analizar desde cero.",
    confirm: "Sí, nueva selección",
  },
  edit: {
    title: "¿Empezar una nueva edición?",
    body: "Se borrará la edición actual y sus XMP. Se conservan las mismas fotos seleccionadas y podrás elegir de nuevo perfil y preset.",
    confirm: "Sí, nueva edición",
  },
};

export default function RestartActions({ canSelect, canEdit, onNewSelection, onNewEdit }) {
  const [ask, setAsk] = useState(null);
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try { await (ask === "selection" ? onNewSelection() : onNewEdit()); setAsk(null); }
    finally { setBusy(false); }
  };
  if (!canSelect && !canEdit) return null;
  const t = ask && TEXTS[ask];
  return (
    <div className="mt-3 flex flex-wrap gap-2 border-t border-zinc-800 pt-3" data-testid="restart-actions">
      {canSelect && <button data-testid="new-selection-btn" onClick={() => setAsk("selection")}
        className="inline-flex items-center gap-2 rounded-md border border-emerald-500/50 px-3 py-2 text-sm text-emerald-300 transition-colors hover:bg-emerald-500/10">
        <RotateCcw className="h-4 w-4" /> Nueva selección
      </button>}
      {canEdit && <button data-testid="new-edit-btn" onClick={() => setAsk("edit")}
        className="inline-flex items-center gap-2 rounded-md border border-sky-500/50 px-3 py-2 text-sm text-sky-300 transition-colors hover:bg-sky-500/10">
        <Wand2 className="h-4 w-4" /> Nueva edición
      </button>}
      <AlertDialog open={!!ask} onOpenChange={(o) => { if (!o && !busy) setAsk(null); }}>
        <AlertDialogContent data-testid="restart-confirm-dialog">
          {t && <>
            <AlertDialogHeader>
              <AlertDialogTitle>{t.title}</AlertDialogTitle>
              <AlertDialogDescription>{t.body}</AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
              <AlertDialogCancel data-testid="restart-cancel-btn" disabled={busy}>Cancelar</AlertDialogCancel>
              <AlertDialogAction data-testid="restart-confirm-btn" disabled={busy} onClick={(e) => { e.preventDefault(); run(); }}>
                {busy ? "Preparando…" : t.confirm}
              </AlertDialogAction>
            </AlertDialogFooter>
          </>}
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
}
